import { FunctionComponent, memo } from "react";
import { IProps } from "./select-menu-message.types";
import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons/faQuestionCircle";
import { Text } from "../../../text";
import { Icon } from "../../../icon";
import { Group } from "../../../group";
import styles from "./select-menu-message.module.scss";
import classNames from "classnames";
import { Flex } from "@mantine/core";
import { Tooltip } from "../../../tooltip";
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons";

/**
 * Component for displaying a message in a select menu, accompanied by an info icon.
 * @param {object} props - The props for the SelectMenuMessage component.
 * @param {string} props.message - The message to display in the select menu.
 * @returns {JSX.Element} SelectMenuMessage component.
 */
const SelectMenuMessage: FunctionComponent<IProps> = ({ message, className, containerProps, messageTooltip }) => {
    return (
        <Group className={classNames(styles["message"], className)} gap="sm" {...containerProps}>
            <Text size="sm" c="dimmed">
                {typeof messageTooltip === "undefined" && (
                    <Flex align="center" mr="sm" display="inline-flex" className={styles["icon-container"]}>
                        <Icon size="sm" icon={faCircleInfo} />
                    </Flex>
                )}
                {message}
            </Text>
            {typeof messageTooltip !== "undefined" && (
                <Flex align="center" display="inline-flex" className={styles["icon-container"]}>
                    <Tooltip label={messageTooltip}>
                        <Icon size="sm" color="black" icon={faQuestionCircle} />
                    </Tooltip>
                </Flex>
            )}
        </Group>
    );
};

export default memo(SelectMenuMessage);
